import React, { useEffect, useState } from 'react';
import { homeownerPost } from '../utils/homeownerApi';
import { CREATE_BUTTON } from '../shared/homeHistoryReport';
import { secondaryButtonStyle } from '../shared/secondaryButton';
import { useTheme } from '../ThemeContext';

const ENDPOINT = '/.netlify/functions/home-history-report';

function actionButton(extra) {
  return Object.assign({
    borderRadius: '0.5rem',
    minHeight: '44px',
    padding: '0.7rem 1rem',
    fontWeight: 650,
    cursor: 'pointer',
  }, extra);
}

export function HomeHistoryRequestCard({
  colors,
  message,
  busy,
  onCreate,
  onDecline,
  onDismiss,
  showCreate,
}) {
  const { isDark } = useTheme();
  const text = (colors && colors.text) || '#1a1a1a';
  const surface = (colors && colors.surface) || '#fff';
  const border = (colors && colors.border) || '#e6e6e6';
  const secondary = secondaryButtonStyle(isDark);
  return (
    <div
      role="status"
      data-testid="home-history-request-notice"
      style={{
        color: text,
        background: surface,
        border: `1px solid ${border}`,
        borderRadius: '0.75rem',
        padding: '0.85rem 1rem',
        marginBottom: '1rem',
      }}
    >
      <p style={{ margin: '0 0 0.75rem', fontWeight: 650 }}>{message}</p>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
        {showCreate !== false && onCreate ? (
          <button
            type="button"
            style={actionButton({ background: '#59c4c4', color: '#fff', border: 'none' })}
            disabled={Boolean(busy)}
            onClick={onCreate}
          >
            {CREATE_BUTTON}
          </button>
        ) : null}
        <button
          type="button"
          style={actionButton(secondary)}
          disabled={Boolean(busy)}
          onClick={onDecline}
        >
          {busy === 'decline' ? 'Declining…' : 'Decline'}
        </button>
        <button
          type="button"
          style={actionButton(secondary)}
          disabled={Boolean(busy)}
          onClick={onDismiss}
        >
          {busy === 'dismiss' ? 'Dismissing…' : 'Dismiss'}
        </button>
      </div>
    </div>
  );
}

export default function HomeHistoryRequestNotice({ colors, onCreate }) {
  const [request, setRequest] = useState(null);
  const [busy, setBusy] = useState('');

  useEffect(() => {
    let cancelled = false;
    if (typeof homeownerPost !== 'function') return undefined;
    homeownerPost(ENDPOINT, { action: 'request-notice' })
      .then((data) => {
        if (cancelled || !data || !data.request) return;
        if (data.request.status === 'requested' && data.request.message && data.request.showCard !== false) {
          setRequest(data.request);
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  async function respond(kind) {
    if (!request || !request.id || busy) return;
    setBusy(kind);
    try {
      await homeownerPost(ENDPOINT, {
        action: kind === 'decline' ? 'decline-request' : 'dismiss-request',
        requestId: request.id,
      });
      setRequest(null);
    } catch (error) {
      setBusy('');
    }
  }

  if (!request) return null;
  return (
    <HomeHistoryRequestCard
      colors={colors}
      message={request.message}
      busy={busy}
      showCreate={Boolean(onCreate)}
      onCreate={onCreate}
      onDecline={() => respond('decline')}
      onDismiss={() => respond('dismiss')}
    />
  );
}
